import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AttendanceParentComponent } from "./attendance-parent.component";
import { AttendnaceComponent } from "./attendance.component";
import { EditTeamAttendnaceComponent } from "./edit-team-attendnace/edit-team-attendnace.component";
import { EmployeeCountByTeamComponent } from "./employees-count-by-team/employees-count-by-team.component";
import { LeaveApplicationComponent } from "./leave-application/leave-application.component";
import { LeaveSummaryComponent } from "./leave-summary/leave-summary.component";
import { MyAttendnaceComponent } from "./my-attendance/my-attendance.component";
import { TeamAttendnaceComponent } from "./team-attendance/team-attendance.component";
import { TeamLeaveApprovalComponent } from "./team-leave-approval/team-leave-approval.component";

const routes: Routes = [
  {path:'',component:AttendanceParentComponent,children:[
    { path: '', component: AttendnaceComponent, children: [
        { path: '',redirectTo: 'my-attendance' , pathMatch: 'full'},
        { path: 'my-attendance', component: MyAttendnaceComponent },
        { path: 'team-attendance', component: TeamAttendnaceComponent},
        { path: 'team-leave-approval', component: TeamLeaveApprovalComponent},
        { path: 'leave-summary', component: LeaveSummaryComponent},
        { path: 'employee-count', component: EmployeeCountByTeamComponent},
       
        
  
        
      ]
    },
    { path: 'leave-application', component: LeaveApplicationComponent},
    { path: 'edit-team-attendance', component: EditTeamAttendnaceComponent}
  ]}
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class AttendanceRoutingModule { }